<template>
    <div>
        <div class="nextStep-tip" v-if="isShowTips">同一航线一次预订最多可选3间舱房</div>
        <div class="room-settleAccount">
            <div class="room-settleAccount-l js-roomDetailBtn">
                <div class="total_amount" :class="{'mar-top': !isDownPayCruise}">
                    <span class="room-settleAccount-count js-totalCount">{{shoppingCarts.length}}</span>
                    <span>间</span>
                    <span class="room-settleAccount-price">￥<span class="js-totalPrice">{{totalAmount}}</span></span>
                    <div class="room-settleAccount-detail" @click="isShowDetail=!isShowDetail">明细&nbsp;<span>&gt;</span></div>
                </div>
                <!-- 订金改为固定文案 -->
                <div v-if="isDownPayCruise" class="total_deposit">
                  <img :src="`${imgUrl}/cruiseSearch/icons/deposit-currency-symbol-white.svg`"/>
                  <span>订金预订￥1000/人起</span>
                </div>
            </div>
            <div class="room-settleAccount-r js-nextBtn" @click="startBooking()">
                下一步&nbsp;乘客信息
            </div>
        </div>
        <div class="roomDetailModel" id="shoppingCartModal" v-show="isShowDetail">
            <div class="roomDetailModel-bg" @click="isShowDetail=!isShowDetail"></div>
            <div class="roomDetailModel-container">
                <div class="roomDetailModel-title">
                    <img src="https://resource.rcclchina.com.cn/mobileSearchPackage/roomIcon.png">
                    <span>已选舱房</span>
                </div>
                <div class="roomDetailModel-con">
                    <!--舱房明细弹窗-->
                    <div class="c_item" v-if="connectRooms.length > 0">
                        <div class="c_img c_comm">
                            <img @click="onShowConnectRoomPopup()" src="https://resource.rcclchina.com.cn/cruiseDetail/mb_con_roompic.png" alt="">
                            <span class="c_delete_content" @click="shoppingCartDelete(connectRooms[0])">
                                <span class="c_num">删除2间</span>
                                <span class="c_delete">x</span>
                            </span>
                        </div>
                        <div class="c_room c_comm" v-for="(shoppingCart, i) in connectRooms" :key="'c_' + i">
                            <div class="c_type">{{getStateroomName(shoppingCart.stateroomPartRecord)}}</div>
                                <div class="c_tui">{{getPriceType(shoppingCart)}}</div>
                            <div class="c_price">￥{{shoppingCart.amount.toFixed("0")}}/舱(含税)</div>
                        </div>
                    </div>

                    <div class="roomDetailModel-item" v-for="(shoppingCart, i) in noConnectRooms" :key="i">
                        <div class="roomDetailModel-item-l">
                            <span>{{getStateroomName(shoppingCart.stateroomPartRecord)}}</span>* 1
                            <div class="unsubscribeFree unsubscribeOpenBtn freeactive" style="display:block;margin-top:6px;">
                                {{getPriceType(shoppingCart)}}
                            </div>
                        </div>
                        <div class="roomDetailModel-item-r">
                            <span class="roomDetailModel-price">¥{{shoppingCart.amount.toFixed("0")}}/舱(含税) </span>
                            <span class="roomDetailModel-delete js-deleteRoomBtn deleteShopRoom" @click="shoppingCartDelete(shoppingCart)">x</span>
                        </div>
                    </div>
                </div>
                <div class="roomDetailModel-closed js-closedBtn" @click="isShowDetail=!isShowDetail"><span class="">X</span></div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/api'
import wechatHelper from '@/utilities/wechatHelper'
import nrpConfig from '@/utilities/nrpConfig'
import {isEmpty} from "@/utilities/tools";
export default {
    name: 'CruiseShoppingCart',
    props: {
        shipCode: {
            type: String,
            default () {
                return ''
            }
        },
        sailDate: {
            type: String,
            default () {
                return ''
            }
        },
        packageCode: {
            type: String,
            default () {
                return ''
            }
        },
        shoppingCarts: {
            type : Array,
            default () {
                return []
            }
        },
        isDownPayCruise: {
          type: Boolean,
          default: false
        },
        onShoppingCartDelete: {
            type: Function
        },
        showConnectRoomPopup: {
            type: Function
        },
        isShowTips: {
            type: Boolean
        }
    },
    data () {
        return {
            imgUrl: process.env.VUE_APP_IMG_URL,
            isShowDetail: false,
            depositPrice: 1000
        }
    },
    beforeMount () {
    },
    methods: {
        getStateroomName(stateroom) {
            if (stateroom) {
                let code = stateroom.stateroomCategoryCode
                 if (code.indexOf('_') >= 0) {
                    code = code.split('_')[0]
                }
                return stateroom.cnName + "_" + code
            }
        },
        getPriceType(shoppingCart) {
            if (shoppingCart.isFortyEightHoursNrpCruise) {
                return nrpConfig.fortyEightHoursNrp.title
            }
            return shoppingCart.isnrp ? nrpConfig.nrp.title: nrpConfig.rp.title
        },
        shoppingCartDelete (shoppingCart) {
            const model =  {
                shipCode: this.shipCode,
                sailDate: this.sailDate,
                productPackageId: -1,
                packageId: this.packageCode,
                stateroomCategoryCode: shoppingCart.berthedCategoryCode,
                stateroomClass: shoppingCart.stateroomType,
                fareCode: shoppingCart.fareCode,
                guestNumber: shoppingCart.guestNumber,
                originAmount: shoppingCart.originAmount,
                netAmount: shoppingCart.netAmount,
                isNrp: shoppingCart.isnrp,
                groupAgencyId: shoppingCart.groupAgencyId,
                groupAgencyName: shoppingCart.groupAgencyName,
                requestSequence: shoppingCart.requestSequence,
                groupType: shoppingCart.groupType,
                groupId: shoppingCart.groupId,
                connectId: shoppingCart.connectId,
                shoppingCartId: shoppingCart.shoppingCartId
            }
            this.onShoppingCartDelete(model)
        },
        onShowConnectRoomPopup () {
            this.showConnectRoomPopup()
        },
        // 开始预订，第一步调用InitStateroom接口初始化预订流程
        // 第二步循环购物车，调用select stateroom接口锁舱
        // 最后一步调用check coupon接口检查是否有赠送优惠券
        async startBooking () {
            if (this.shoppingCarts.length == 0) return

            try {
                if (window.gio && this.shoppingCarts.some(r=>r.isnrp == true)) {
                    window.gio('track', 'NRP_BF02')
                }
            } catch (e) {
                console.error(e);
            }
            const shipCode = this.shoppingCarts[0].shipCode
            const sailDate = this.shoppingCarts[0].sailDate
            this.$loading.show()
            let bookingKey = this.$store.state.booking.bookingKey
            const { success, data, errMsg } = await api.booking.initStateroom(bookingKey)
            this.$loading.hide()
            if (!success) {
                this.$alert.show(errMsg)
                return
            } else {
                this.$store.dispatch('SET_BOOKING_KEY', data)
                bookingKey = data
            }
            const result = await this.selectStateroomApi(bookingKey)
            if (result.successShoppingCarts.length > 0 && result.failureShoppingCarts.length == 0) {
                // 全部成功，进入下一步
                this.goToGuestInfo(shipCode, sailDate, result.successShoppingCarts)
            } else if (result.failureShoppingCarts.length > 0) {
                if (result.successShoppingCarts.length == 0) {
                    // 全部失败，提示重新选择
                    const staterooms = result.failureShoppingCarts.filter(r=>r.stateroomPartRecord && r.stateroomPartRecord.cnName)
                    .map(r=>r.stateroomPartRecord.cnName)
                    this.$alert.show(`您选择的${staterooms.join('，')}已经售罄，已为您删除，您可以返回重新选择。`)

                } else if (result.successShoppingCarts.length > 0) {
                    // 有成功有失败，用户自己选择继续还是重新选择
                    const staterooms = result.failureShoppingCarts.filter(r=>r.stateroomPartRecord && r.stateroomPartRecord.cnName)
                    .map(r=>r.stateroomPartRecord.cnName)
                    this.$confirm.show(`您选择的${staterooms.join('，')}已经售罄，已为您删除，您可以继续填写乘客信息或者返回重新选择。`, {
                        confirmBtn: '填写乘客信息',
                        cancelBtn: '返回重新选择',
                        confirmCallBack: ()=> {
                            this.goToGuestInfo(shipCode, sailDate, result.successShoppingCarts)
                        }
                    })
                }

                // 删除失败的房间
                const failureConnects = result.failureShoppingCarts.filter(r=>r.connectId && r.connectId.length > 0)
                const failureNormals = result.failureShoppingCarts.filter(r=>!r.connectId || r.connectId=='')
                if (failureConnects.length > 0) {
                    this.onShoppingCartDelete(failureConnects[0])
                }
                if (failureNormals.length > 0) {
                    failureNormals.forEach((sc) => {
                        this.onShoppingCartDelete(sc)
                    })
                }
            }
        },
        // 提交购物车各个舱房
        // 返回定义, successShoppingCarts: [], failureShoppingCarts: []
        async selectStateroomApi (bookingKey) {
            this.$loading.show()
            let result = {
                successShoppingCarts: [],
                failureShoppingCarts: []
            }
            // 先处理连通房，如果连通房有一间不成功，那都不成功
            if (this.connectRooms.length == 2) {
                for (let i = 0; i < this.connectRooms.length; i++) {
                    const shoppingCart = this.connectRooms[i]
                    const requestData = this.getSelectStateroomRequest(bookingKey, shoppingCart)
                    const { success } = await api.booking.selectStateroom(requestData)
                    if (!success) {
                        result.successShoppingCarts = []
                        result.failureShoppingCarts = result.failureShoppingCarts.concat(this.connectRooms)
                        break
                    } else {
                        result.successShoppingCarts.push(shoppingCart)
                    }
                }
            }

            // 处理普通房型
            if (this.noConnectRooms.length > 0) {
                for (let i = 0; i < this.noConnectRooms.length; i++) {
                    let shoppingCart = this.noConnectRooms[i]
                    const requestData = this.getSelectStateroomRequest(bookingKey, shoppingCart)
                    const { success } = await api.booking.selectStateroom(requestData)
                    if (!success) {
                        result.failureShoppingCarts.push(shoppingCart)
                    } else {
                        result.successShoppingCarts.push(shoppingCart)
                    }
                }
            }
            this.$loading.hide()
            return result
        },
        // 组装select stateroom request
        getSelectStateroomRequest (bookingKey, shoppingCart) {
            let tikTokCode = "";
            if(!isEmpty(sessionStorage.getItem("tikTokCode"))) {
              tikTokCode = sessionStorage.getItem("tikTokCode");
            }
            let requestData = {
                bookingKey,
                sailDate: shoppingCart.sailDate,
                shipCode: shoppingCart.shipCode,
                stateroomCategoryCode: shoppingCart.berthedCategoryCode,
                fareCode: shoppingCart.fareCode,
                agencyId: this.agencyId,
                guestNumber: shoppingCart.guestNumber,
                isnrp: shoppingCart.isnrp,
                groupAgencyId: shoppingCart.groupAgencyId || '',
                groupAgencyName: shoppingCart.groupAgencyName || '',
                requestSequence: shoppingCart.requestSequence || '',
                groupType: shoppingCart.groupType || '',
                groupId: shoppingCart.groupId || '',
                connectId: shoppingCart.connectId || '',
                isConnectRoom: (shoppingCart.connectId && shoppingCart.connectId.length > 0),
                tikTokCouponCode: tikTokCode
            }

            try {
                if(window && window.gio){
                    if(requestData.isnrp){
                        window.gio('track', 'NRP_BF02');
                    }
                }
            } catch (e) {
                console.error(e)
            }

            return requestData
        },
        // 检查是否有赠送优惠券，并进入填写信息页面
        async goToGuestInfo (shipCode, sailDate, successShoppingCarts) {
            const stateroomCodes = successShoppingCarts.map(r=>r.berthedCategoryCode)
            const requestData = {
                request: {
                    shipCode: shipCode,
                    sailDate: sailDate,
                    stateroomCategoryCodes: stateroomCodes
                }
            }
            this.$loading.show()
            const { success, data } = await api.booking.checkCoupon(requestData)
            this.$loading.hide()
            if (!success || !data || !data.couponInfos || data.couponInfos.length == 0) {
                 this.$router.push({
                    name: "GuestInfo",
                    query: {
                        shipCode,
                        sailDate
                    }
                })
                return
            }

            let text = '您已领取了 ';
            let couponText = "";
            for (var i = 0; i < data.couponInfos.length; i++) {
                var couponInfo = data.couponInfos[i];
                if (couponInfo.getCount > 0) {
                    couponText += "，" + couponInfo.getCount + "张" + couponInfo.couponType;
                }
            }
            if (couponText.length > 0) {
                couponText = couponText.substr(1);
                text = text + couponText + "，可在下一乘客信息填写页面选择使用优惠券"
                const self = this
                this.$alert.show(text, {
                    confirmCallBack: () => {
                        self.$router.push({
                            name: "GuestInfo",
                            query: {
                                shipCode,
                                sailDate
                            }
                        })
                    }
                })
            } else {
                this.$router.push({
                    name: "GuestInfo",
                    query: {
                        shipCode,
                        sailDate
                    }
                })
            }


        },
        deleteShoppingCarts(shoppingCarts) {
            shoppingCarts.forEach((shoppingCart)=> {
                this.onShoppingCartDelete(shoppingCart)
            })
        }
    },
    computed: {
        totalAmount () {
            let amount = 0
            this.shoppingCarts.forEach((shoppingCart) => {
                amount += shoppingCart.amount
            })
            return amount.toFixed("0")
        },
        totalDeposit() {
          let deposit = 0;
          this.shoppingCarts.forEach((shoppingCart) => {
            deposit += shoppingCart.guestNumber;
          });
          return this.depositPrice * deposit;
        },
        //包含套房
        isDeluxeStateroom() {
          let deluxeNum = 0;
          if(this.shoppingCarts) {
            this.shoppingCarts.forEach((row)=> {
              if(row.stateroomType === "DELUXE") {
                deluxeNum+=1;
              }
            })
          }
          return deluxeNum > 0;
        },
        connectRooms () {
            return this.shoppingCarts.filter(r=>r.connectId && r.connectId.length > 0)
        },
        noConnectRooms () {
            return this.shoppingCarts.filter(r=>!r.connectId || r.connectId.length == 0)
        },
        agencyId () {
            if (wechatHelper.isWeixinBrowser()) {
                return "347880"
            }
            return '336801'
        }
    }
}
</script>

<style lang="less" scoped>
.nextStep-tip {
    font-size: 10px;
    line-height: 21px;
    color: #666;
    text-align: center;
    background: #F7F7F7;
    position: fixed;
    bottom: 94px;
    width: 100%;
}
.room-settleAccount{
    position: fixed;
    bottom: 44px;
    left: 0;
    z-index: 101;
    width: 100%;
    overflow: hidden;
    .room-settleAccount-l {
        width: 250px;
        height: 50px;
        padding: 4px 0 7px 20px;
        background-image: -webkit-gradient(linear, left top, right top, color-stop(21%, #4A90E2), to(#1A92E0));
        background-image: -webkit-linear-gradient(left, #4A90E2 21%, #1A92E0 100%);
        background-image: -moz-linear-gradient(left, #4A90E2 21%, #1A92E0 100%);
        background-image: -o-linear-gradient(left, #4A90E2 21%, #1A92E0 100%);
        background-image: linear-gradient(90deg, #4A90E2 21%, #1A92E0 100%);
        font-size: 14px;
        color: #fff;
        float: left;
        & .total_amount {
          &.mar-top {
            margin-top: 9px;
          }
          .room-settleAccount-count {
            font-family: PingFang-SC-Medium;
            /* font-size: 18px; */
            color: #FFFFFF;
            letter-spacing: 0;
          }
          >span {
            display: inline-block;
            vertical-align: middle;
            line-height: initial;
          }
          >span.room-settleAccount-price {
            font-family: PingFang-SC-Medium;
            font-size: 14px;
            color: #FFFFFF;
            letter-spacing: 0;
            padding: 0 6px;
            line-height: normal;
            border-left: 1px solid #fff;
            border-right: 1px solid #fff;
            margin: 0 4px;
            display: inline-block;
            vertical-align: middle;
            line-height: 10px;
            span {
              font-size: 18px;
              font-weight: bold;
            }
          }
        }
        & .total_deposit {
            margin-left: -2px;
            width: 112px;
            height: 16px;
            background: #00BBFE;
            border-radius: 3px;
            display: flex;
            align-items: center;
            justify-content: center;
          & > img {
            width: 10px;
            height: 10px;
          }
          & > span {
            font-weight: 500;
            font-size: 9px;
            color: #FFFFFF;
            margin-left: 2px;
          }
        }
        .room-settleAccount-detail {
            font-family: PingFang-SC-Medium;
            font-size: 14px;
            color: #FFFFFF;
            letter-spacing: 0;
            display: inline-block;
            vertical-align: middle;
            span {
                display: inline-block;
                color: #fff;
                font-size: 14px;
                transform: rotate(-90deg) scaleY(1.5);
                -webkit-transform: rotate(-90deg) scaleY(1.5);
                -moz-transform: rotate(-90deg) scaleY(1.5);
                -ms-transform: rotate(-90deg) scaleY(1.5);
                -o-transform: rotate(-90deg) scaleY(1.5);
            }
        }
    }

    .room-settleAccount-r {
        float: left;
        width: calc(100% - 250px);
        height: 50px;
        padding: 10px 0;
        background-image: -webkit-gradient(linear, right top, left top, from(#FAD961), to(#FEBC10));
        background-image: -webkit-linear-gradient(right, #FAD961 0%, #FEBC10 100%);
        background-image: -moz-linear-gradient(right, #FAD961 0%, #FEBC10 100%);
        background-image: -o-linear-gradient(right, #FAD961 0%, #FEBC10 100%);
        background-image: linear-gradient(270deg, #FAD961 0%, #FEBC10 100%);
        font-family: PingFang-SC-Medium;
        font-size: 14px;
        color: #454545;
        letter-spacing: 0;
        text-align: center;
        line-height: 29.13px;
    }
}

.roomDetailModel {
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    bottom: 94px;
    z-index: 100;
    .roomDetailModel-bg {
        background-color: rgba(0,0,0,.4);
        position: fixed;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        bottom: 94px;
    }
    .roomDetailModel-container {
        background-color: #fff;
        border-top: 5px solid #FEBC10;
        padding: 22px 20px 13px 20px;
        position: absolute;
        bottom: 0;
        width: 100%;
        .roomDetailModel-title {
            padding-bottom: 8px;
            margin-bottom: 12px;
            img {
                width: 22px;
                vertical-align: middle;
            }
            span {
                display: inline-block;
                vertical-align: middle;
                font-family: PingFang-SC-Medium;
                font-size: 14px;
                color: #4A90E2;
                letter-spacing: 1px;
            }
        }
        .roomDetailModel-con {
            margin-top: 12px;
            .roomDetailModel-item {
                margin-bottom: 12px;
                line-height: initial;
                height: 38px;
                .roomDetailModel-item-l {
                    float: left;
                    font-family: PingFang-SC-Medium;
                    font-size: 12px;
                    color: #333333;
                    letter-spacing: 0;
                    .unsubscribeFree {
                        width: 56px;
                        background: #4A90E2;
                        border-radius: 9px;
                        font-size: 10px;
                        color: #FFFFFF;
                        text-align: center;
                        line-height: 16px;
                    }
                }

                .roomDetailModel-item-r {
                    float: right;
                    position: relative;
                    top: -2px;
                    .roomDetailModel-price {
                        font-family: PingFang-SC-Medium;
                        font-size: 12px;
                        color: #333333;
                        letter-spacing: 0;
                        text-align: right;
                    }
                    .roomDetailModel-delete {
                        display: inline-block;
                        width: 15px;
                        text-align: center;
                        height: 15px;
                        font-size: 13px;
                        line-height: 13px;
                        background-color: #ccc;
                        border-radius: 50%;
                        -webkit-border-radius: 50%;
                        color: #fff;
                        margin-left: 6px;
                    }
                }
            }
            .roomDetailModel-item::after {
                content: '';
                clear: both;
            }

            .c_item {
                border-top: 2px solid #FEBC10;
                border-bottom: 2px solid #FEBC10;
                background-color: #FFF7CD;
                margin-left: -20px;
                margin-right: -20px;
                margin-bottom: 10px;
                font-family: PingFang-SC-Medium;
                padding-bottom: 6px;
                .c_comm {
                    margin-left: 20px;
                }
                .c_img {
                    margin-bottom: 7px;
                    margin-top: 22px;
                    >img {
                        width: 98px;
                        height: 17px;
                    }
                    .c_delete_content {
                        display: inline-block;
                        float: right;
                    }
                    .c_num {
                        float: right;
                        margin-right: 41px;
                        font-size: 12px;
                        color: #666666;
                        line-height: 20px;
                    }
                    .c_delete {
                        float: right;
                        width: 15px;
                        text-align: center;
                        height: 15px;
                        font-size: 13px;
                        line-height: 13px;
                        background-color: #ccc;
                        border-radius: 50%;
                        -webkit-border-radius: 50%;
                        color: #fff;
                        margin-right: -66px;
                        margin-top: 3px;
                    }
                    .c_delete_content::after {
                        content: '';
                        clear: both;
                    }
                }
                .c_type {
                    font-size: 12px;
                    color: #333333;
                    line-height: 20px;
                    margin-bottom: 2px;
                    font-weight: 400;
                }
                .c_tui {
                    width: 56px;
                    background: #4A90E2;
                    border-radius: 9px;
                    font-size: 10px;
                    color: #FFFFFF;
                    text-align: center;
                    line-height: 16px;
                    margin-bottom: 5px;
                }
                .c_price {
                    float: right;
                    font-size: 12px;
                    color: #333333;
                    margin-right: 41px;
                    margin-top: -29px;
                }

            }

        }

        .roomDetailModel-closed {
            width: 38px;
            text-align: center;
            height: 34px;
            line-height: 34px;
            position: absolute;
            top: -4px;
            right: -4px;
            background: #FEBC10;
            border-bottom-left-radius: 8px;
            -webkit-border-bottom-left-radius: 8px;
            border-bottom-right-radius: 8px;
            -webkit-border-bottom-right-radius: 8px;
             > span {
                display: inline-block;
                color: #fff;
                font-size: 16px;
                -webkit-transform: scale(1.5,1.3);
                -moz-transform: scale(1.5,1.3);
                -ms-transform: scale(1.5,1.3);
                -o-transform: scale(1.5,1.3);
                transform: scale(1.5,1.3);
            }
        }
    }
}



</style>
